import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  ChronicleActions,
  ImageActions,
  TimelineActions,
} from "../../../_actions";
import { PaneLoader } from "../../../_components";
import { useApp } from "../../../_contexts";

export function SubmittingPage({ navMethods, store, getCalendar }) {
  const [isLoading, setIsLoading] = useState(false);
  const { details: world } = useSelector((state) => state.world);
  const { data: chronicle } = useSelector((state) => state.chronicle);
  const { user } = useApp();
  const dispatch = useDispatch();

  const processImageField = (value, type = "map") => {
    //create form and submit
    return new Promise((resolve, reject) => {
      if (!value || value === null || value.length === 0) {
        resolve(false);
        return;
      }
      const formData = new FormData();
      formData.append("name", type === "map" ? "Default Map" : "Default Cover");
      formData.append("imageType", type);
      formData.append("world", world._id);
      formData.append("chronicle", chronicle._id);
      formData.append("waUser", user.userID);
      formData.append("images", Array.isArray(value) ? value[0] : value);

      dispatch(ImageActions.upload(formData))
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  };

  const processTimelineField = (name) => {
    return new Promise((resolve, reject) => {
      //get timelineName
      const newTimeline = {
        worldID: world._id,
        chronicleID: chronicle._id,
        timeline: {
          title: name && name.length > 0 ? name : "Default Timeline",
          order: 0,
          description: "",
          private: chronicle.private,
          active: true,
        },
      };

      dispatch(TimelineActions.newTimeline(newTimeline))
        .then((timeline) => {
          resolve(timeline);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  };

  const processChronicleFields = (defaults) => {
    return new Promise((resolve, reject) => {
      const newChronicle = {
        defaultMap:
          defaults.map && defaults.map.length > 0 ? defaults.map : null,
        defaultCover:
          defaults.cover && defaults.cover.length > 0 ? defaults.cover : null,
        defaultCalendar: getCalendar(store),
        unitDisplayCount: store.unitCount,
        defaultUnit: store.defaultUnit,
        startDate: store.startDate,
        setupComplete: true,
        private: chronicle.private,
        title: chronicle.title,
        description: chronicle.description,
      };
      console.log(newChronicle);
      //get calendar
      dispatch(ChronicleActions.saveChronicle(chronicle._id, newChronicle))
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
    //Format the formdata and link in image fields
  };

  const submitForm = () => {
    let defaults = {
      timeline: "",
      map: "",
      cover: "",
    };
    // console.log("Store:", store);
    // return;
    setIsLoading(true);
    processImageField(store.map, "map")
      .then((result) => {
        if (result && result[0]._id) {
          defaults.map = result[0]._id;
        }
        return processImageField(store.cover, "cover");
      })
      // .then(() => {})
      .then((result) => {
        if (result && result[0]._id) {
          defaults.cover = result[0]._id;
        }
        return processTimelineField(store.timelineName);
      })
      .then((timeline) => {
        if (timeline && timeline._id) {
          defaults.timeline = timeline._id;
        }
        return processChronicleFields(defaults);
      })
      .then((chronicleResult) => {
        if (chronicleResult) {
          // setIsLoading(false);
          // console.log("All done!");
          navMethods.nextTab();
        }
      })
      .catch((err) => {
        console.log("Error!", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    navMethods && navMethods.setShowNavigation(false);
    submitForm();
  }, []);

  return (
    <div className="chronos-submitting-page">
      <PaneLoader isLoading={true} text="Chronicle" isNew />
    </div>
  );
}
